import { Card, Icon, Link, Text } from '@chakra-ui/react';
import { ElementType } from 'react';

type Props = {
  IconComponent: ElementType;
  text: string;
  url: string;
};

const HelpMessageIcon = ({ IconComponent, text, url }: Props): JSX.Element => {
  return (
    <Card direction={'row'} variant={'unstyled'} gap={'4px'} alignItems={'center'}>
      <Icon as={IconComponent} />
      <Link href={url} isExternal>
        <Text fontWeight={500}>{text}</Text>
      </Link>
    </Card>
  );
};

export default HelpMessageIcon;
